const { Badge } = require("react-bootstrap");

const TagSinDatos = () => <Badge variant="light">SIN DATOS</Badge>

export default TagSinDatos